export default "__VITE_ASSET__HAjZ6hpI__"